import type { BatchLiabilityResultItem } from '@/features/cbam-reporting/hooks/cbamLiability'

export type LiabilityProjectionDerived = {
  specificDirectEmissions: number | undefined
  specificIndirectEmissions: number | undefined
  specificFreeAllocation: number | undefined
  specificTotalEmissions: number | undefined
  totalEmissions: number | undefined
  totalFreeAllocation: number | undefined
  netEmissions: number | undefined
  netEmissionsPerTonne: number | undefined
  specificIncludedEmissions: number | undefined
}

export function getLiabilityProjectionDerivedForYear(
  liabilityData: BatchLiabilityResultItem | null,
  projectionYear: number
): LiabilityProjectionDerived {
  const projection = liabilityData?.result?.projection?.[projectionYear]

  const specificDirectEmissions = projection?.specificDirectEmbeddedEmissions ?? undefined
  const specificIndirectEmissions = projection?.specificIndirectEmbeddedEmissions ?? undefined
  const specificFreeAllocation = projection?.specificFreeAllocationTCo2Pt ?? undefined
  const specificTotalEmissions = projection?.specificTotalEmbeddedEmissions ?? undefined
  const totalEmissions = projection?.totalEmissions ?? undefined
  const totalFreeAllocation = projection?.freeAllocationTCo2 ?? undefined
  const netEmissions = projection?.netEmissions ?? undefined
  const netEmissionsPerTonne = projection?.netEmissionsPerTonne ?? undefined

  const specificIncludedEmissions =
    specificTotalEmissions !== undefined && specificTotalEmissions !== null
      ? specificTotalEmissions
      : specificDirectEmissions !== undefined &&
          specificIndirectEmissions !== undefined &&
          specificFreeAllocation !== undefined
        ? specificDirectEmissions + specificIndirectEmissions - specificFreeAllocation
        : undefined

  return {
    specificDirectEmissions,
    specificIndirectEmissions,
    specificFreeAllocation,
    specificTotalEmissions,
    totalEmissions,
    totalFreeAllocation,
    netEmissions,
    netEmissionsPerTonne,
    specificIncludedEmissions
  }
}
